import VideoInput from './VideoInput';
export { VideoInput }



// WEBPACK FOOTER //
// ./src/components/form/VideoInput/index.js